import RsvpLiteGuestsPage from './rsvp-lite-guests';
import RsvpService from '../../services/RsvpService';

const state = {
  	name: 'rsvp-lite-manage-guests',
  	url: '/rsvp-lite/manage-guests/:account_uuid/:contact_uuid/:event_id',
  	component: RsvpLiteGuestsPage,
    resolve: [
        {
            token: 'data',
            deps: ['$transition$'],
            resolveFn: (trans) => new RsvpService().getRsvp(trans.params())
        }
    ]
};

export default state;
